import { render, staticRenderFns } from "./ListDisease.vue?vue&type=template&id=d7887b04&scoped=true&"
import script from "./ListDisease.vue?vue&type=script&lang=js&"
export * from "./ListDisease.vue?vue&type=script&lang=js&"
import style0 from "./ListDisease.vue?vue&type=style&index=0&id=d7887b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7887b04",
  null
  
)

export default component.exports